// Module
var code = `<div class='customer-loans-gl-payment'>
  <form name="\$ctrl.form">

    <div class="alert alert--danger" ng-if="\$ctrl.simulationError">
      {{\$ctrl.simulationError}}
    </div>
    <form-section form-title="'Pre-termination Revert to GL'">
      <paid-amortizations
        amortizations="\$ctrl.paidAmortizations"
        operation="\$ctrl.operation"
        summary="\$ctrl.paidAmortizationsSummary">
      </paid-amortizations>
    </form-section>

    <gl-payment
        operation="\$ctrl.operation"
        branch="\$ctrl.branch"
        remarks="\$ctrl.remarks"
        action-type="'LOAN_GL_PAYMENT_REVERT'">
    </gl-payment>

    <validator condition="!\$ctrl.simulationError" ></validator>

    <div class="buttons flex-end">
      <button type="button" class="btn btn-warning" ng-click="\$ctrl.redirectBack()">Cancel</button>
      <button type="button" class="btn btn-success" ng-click="\$ctrl.revert()" ng-disabled="\$ctrl.form.\$invalid">
        Confirm
      </button>
    </div>
  </form>
</div>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/loans/preterminate-revert/loans-preterminate-revert-to-gl.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;